(function () {
  'use strict';

  const reserveTimers = new WeakMap();
  const PULSE_AT_SECONDS = 30;
  const STORAGE_KEY = 'wbs-cart-reserve-timer-end';
  const ROOT_SELECTOR = '#wbs-cart-reserve-timer';
  const INIT_ATTR = 'data-wbs-cart-reserve-timer-init';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function destroyCartReserveTimer(el) {
    const state = reserveTimers.get(el);
    if (!state) return;
    if (state.rafId) cancelAnimationFrame(state.rafId);
    reserveTimers.delete(el);
    el.removeAttribute(INIT_ATTR);
  }

  function getEndTime(totalSecs) {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        const endTime = parseInt(stored, 10);
        if (endTime > Date.now()) return endTime;
      }
    } catch (_) {}

    const endTime = Date.now() + totalSecs * 1000;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(endTime));
    } catch (_) {}
    return endTime;
  }

  function saveEndTime(endTime) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(endTime));
    } catch (_) {}
  }

  function initCartReserveTimer(el) {
    if (!el || !el.isConnected) return;
    if (el.hasAttribute(INIT_ATTR)) return;

    const totalSecs = parseInt(el.dataset.countdown, 10) || 600;
    const showTimer = el.dataset.showTimer !== 'false';
    const animPulse = el.dataset.animatePulse !== 'false';
    const barText = el.dataset.barText || '';

    const minEl = el.querySelector('[data-role="minutes"]');
    const secEl = el.querySelector('[data-role="seconds"]');
    const timerEl = el.querySelector('.wbs-cart-reserve-timer__timer');

    let endTime = getEndTime(totalSecs);

    const state = { rafId: null };
    reserveTimers.set(el, state);
    el.setAttribute(INIT_ATTR, '');

    function render(remaining) {
      if (!el.isConnected) {
        destroyCartReserveTimer(el);
        return;
      }

      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      if (showTimer && timerEl) {
        if (minEl) minEl.textContent = pad(minutes);
        if (secEl) secEl.textContent = pad(seconds);
      }

      if (animPulse) {
        el.classList.toggle('wbs-cart-reserve-timer--ending', remaining <= PULSE_AT_SECONDS);
      }

      const timeStr = minutes + ' minutes and ' + seconds + ' seconds remaining';
      el.setAttribute('aria-label', barText ? barText + ': ' + timeStr : timeStr);
    }

    function tick() {
      if (!el.isConnected) {
        destroyCartReserveTimer(el);
        return;
      }

      let remaining = Math.round((endTime - Date.now()) / 1000);

      if (remaining <= 0) {
        endTime = Date.now() + totalSecs * 1000;
        saveEndTime(endTime);
        el.classList.remove('wbs-cart-reserve-timer--ending');
        remaining = totalSecs;
      }

      render(remaining);
      state.rafId = requestAnimationFrame(tick);
    }

    render(Math.max(0, Math.round((endTime - Date.now()) / 1000)));
    state.rafId = requestAnimationFrame(tick);
  }

  function initCartReserveTimers(root) {
    const scope = root && root.querySelector ? root : document;
    const el = scope.querySelector
      ? scope.querySelector(`${ROOT_SELECTOR}:not([${INIT_ATTR}])`)
      : null;
    if (el) initCartReserveTimer(el);
  }

  function setupCartDrawerObserver() {
    const drawer =
      document.querySelector('cart-drawer-component') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('#cart-drawer');
    if (!drawer || drawer.hasAttribute('data-wbs-cart-reserve-timer-observer')) return;

    drawer.setAttribute('data-wbs-cart-reserve-timer-observer', '');
    const observer = new MutationObserver(() => {
      if (drawer.querySelector(`${ROOT_SELECTOR}:not([${INIT_ATTR}])`)) {
        initCartReserveTimers(drawer);
      }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function onReady() {
    initCartReserveTimers(document);
    setupCartDrawerObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(() => {
        initCartReserveTimers(
          document.querySelector('cart-drawer-component') ||
            document.querySelector('cart-drawer') ||
            document
        );
      });
    });
  }

  document.addEventListener('shopify:section:unload', () => {
    const el = document.querySelector(ROOT_SELECTOR);
    if (el) destroyCartReserveTimer(el);
  });

  document.addEventListener('shopify:section:load', () => {
    initCartReserveTimers(
      document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer') ||
        document
    );
  });

  window.WbsCartReserveTimer = {
    init: initCartReserveTimers,
    destroy: destroyCartReserveTimer,
  };
})();
